import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import TruncatedHtml from "../../user_content/truncated_html";

export default GrComponentFactory.createClass({
  displayName: "AuthorBlogPostNewsfeedItem",

  propTypes: {
    resource: GrPropTypes.authorBlogPostNewsfeedResource(),
  },

  renderBody() {
    return (
      <div className="gr-newsfeedItem__authorBlog">
        <a className="gr-newsfeedItem__resourceNameLink"
           href={this.props.resource.url}>
          { this.props.resource.title }
        </a>
        <TruncatedHtml {...this.props.resource.body}
                       fullContentText="Read post" />
      </div>
    );
  },

  render() {
    return <SocialUpdate
      header={<span>wrote a new blog post</span>}
      body={this.renderBody()}
      {...this.props}
      resource={this.props.resource}
      />;
  },
});
